module.exports = __webpack_public_path__ + "img/500.2b6dc2d1.svg";